// Project urls
// After adding new page and url for it here, key for url should be added in constants.ts
// in relevant group: notAuthPages, profilePages, billsPages, servicesPages, applicationPages, supportPages
export const urls = {
	// Login
	login: '/Privatni/Prijava',
	trustedLogin: '/Privatni/Prijava/Trusted-user',
	// Registration
	registration: '/Privatni/Registracija',
	registrationConfirmation: '/Privatni/Potvrda-registracije',
	registrationLinkExpired: '/Privatni/Istekao-verifikacioni-link',
	// Forgotten Password
	forgottenPassword: '/Privatni/Zaboravljena-lozinka',
	passwordConfirmation: '/Privatni/Zaboravljena-lozinka/Potvrda-lozinke',
	forgottenPasswordLinkExpired: '/Privatni/Zaboravljena-lozinka/Istekao-link',
	newPassword: '/Privatni/Zaboravljena-lozinka/Nova-lozinka',
	passwordChanged: '/Privatni/Promijenjena-lozinka',
	// My profile
	linkedAccounts: '/Privatni/Uvezane-usluge',
	changeEmail: '/Privatni/Promjena-email-adrese',
	changeEmailLinkExpired: '/Privatni/Istekao-token',
	deleteAccount: '/Privatni/Brisanje-naloga',
	changePassword: '/Privatni/Promjena-lozinke',
	// Account without any CustomerID
	addService: '/Privatni/Dodajte-uslugu',
	// Mobile prepaid
	mobilePrepaidOverview: '/Privatni/Prepaid/Pregled',
	changeTariff: '/Privatni/Prepaid/Promjena-tarife',
	topUp: '/Privatni/Prepaid/Online-dopuna',
	tariffOptions: '/Privatni/Prepaid/Tarifne-opcije',
	prepaidNumbers: '/Privatni/Prepaid/Moji-brojevi',
	parkingPrepaid: '/Privatni/Prepaid/Parking',
	personalOfferPrepaid: '/Privatni/Prepaid/Moja-ponuda',
	overviewAppsPrepaid: '/Privatni/Prepaid/Aplikacije',
	// Mobile postpaid
	mobilePostpaidOverview: '/Privatni/Postpaid/Pregled',
	postpaidTopUp: '/Privatni/Postpaid/Online-dopuna',
	additionalServices: '/Privatni/Postpaid/Parking-i-usluge',
	changeTariffPostpaid: '/Privatni/Postpaid/Promjena-tarife',
	postpaidTariffOptions: '/Privatni/Postpaid/Tarifne-opcije-i-dodaci',
	postpaidNumbers: '/Privatni/Postpaid/Prijatelj-broj',
	personalOfferPostpaid: '/Privatni/Postpaid/Moja-ponuda',
	overviewAppsPostpaid: '/Privatni/Postpaid/Aplikacije',
	// Mobile postpaid in Package
	mobilePostpaidOverviewPackage: '/Privatni/Mobilna/Pregled',
	postpaidTariffOptionsPackage: '/Privatni/Mobilna/Tarifne-opcije',
	personalOfferPostpaidPackage: '/Privatni/Mobilna/Moja-ponuda',
	postpaidTopUpPackage: '/Privatni/Mobilna/Online-dopuna',
	changeTariffPostpaidPackage: '/Privatni/Mobilna/Promjena-tarife',
	additionalServicesPackage: '/Privatni/Mobilna/Parking-i-usluge',
	postpaidNumbersPackage: '/Privatni/Mobilna/Prijatelj-broj',
	overviewAppsPostpaidPackage: '/Privatni/Mobilna/Aplikacije',
	// Internet
	internetOverview: '/Privatni/Kucni-internet/Pregled',
	changeTariffInternet: '/Privatni/Kucni-internet/Promjena-tarife',
	personalOfferInternet: '/Privatni/Kucni-internet/Moja-ponuda',
	overviewAppsInternet: '/Privatni/Kucni-internet/Aplikacije',
	// Kombinuj
	kombinujOverview: '/Privatni/Kombinuj/Pregled',
	kombinujTopUp: '/Privatni/Kombinuj/Online-dopuna',
	combineTariffOptions: '/Privatni/Kombinuj/Tarifne-opcije',
	combineNumbers: '/Privatni/Kombinuj/Prijatelj-broj',
	parkingCombine: '/Privatni/Kombinuj/Parking',
	personalOfferCombine: '/Privatni/Kombinuj/Moja-ponuda',
	overviewAppsCombine: '/Privatni/Kombinuj/Aplikacije',
	// Dopuna NET (Prepaid mobile internet )
	additiveNetOverview: '/Privatni/Dopuna-net/Pregled',
	additiveNetTopUp: '/Privatni/Dopuna-net/Online-dopuna',
	additiveTariffOptions: '/Privatni/Dopuna-net/Tarifne-opcije',
	parkingAdditive: '/Privatni/Dopuna-net/Parking',
	personalOfferAdditive: '/Privatni/Dopuna-net/Moja-ponuda',
	overviewAppsAdditive: '/Privatni/Dopuna-net/Aplikacije',
	// TV
	tvOverview: '/Privatni/Televizija/Pregled',
	tvChannels: '/Privatni/Televizija/Lista-kanala',
	additionalStbDevices: '/Privatni/Televizija/Dodatni-STB-uredjaji',
	iptvShop: '/Privatni/Televizija/IPTV-shop',
	personalOfferTv: '/Privatni/Televizija/Moja-ponuda',
	tvToGo: '/Privatni/Televizija/TV-To-Go',
	tvToGoConfirmation: '/Privatni/Televizija/TV-To-Go/Poslan-mejl',
	tvToGoSuccess: '/Privatni/Televizija/TV-To-Go/Uspjesna-registracija',
	overviewAppsTv: '/Privatni/Televizija/Aplikacije',
	// mSAT
	msatOverview: '/Privatni/mSAT-Televizija/Pregled',
	msatChannels: '/Privatni/mSAT-Televizija/Lista-kanala',
	msatAddons: '/Privatni/mSAT-Televizija/Dodatni-paketi',
	msatAdditionalStbDevices: '/Privatni/mSAT-Televizija/Dodatni-STB-uredjaji',
	overviewAppsMsat: '/Privatni/mSAT-Televizija/Aplikacije',
	// TEL postpaid (solo)
	fixedTelephonyOverview: '/Privatni/Postpaid-TEL/Pregled',
	fixedTelephonyTariffOptions: '/Privatni/Postpaid-TEL/Tarifne-opcije',
	fixedNumbers: '/Privatni/Postpaid-TEL/Prijatelj-broj',
	personalOfferFixed: '/Privatni/Postpaid-TEL/Moja-ponuda',
	overviewAppsFixed: '/Privatni/Postpaid-TEL/Aplikacije',
	// Bills
	billsOverview: '/Privatni/Racuni/Pregled-racuna',
	eBillsOverview: '/Privatni/Racuni/Moj-racun',
	activationOnWord: '/Privatni/Racuni/Ukljucenje-na-rijec',
	payBillForAnother: '/Privatni/Racuni/Plati-kao-drugo-lice',
	// Apps
	siguranNetOverview: '/Privatni/Aplikacije/SiguranNet',
	apollonOverview: '/Privatni/Aplikacije/Apollon',
	apollonUserGuide: '/Privatni/Aplikacije/Apollon/Uputstvo-za-koriscenje',
	arenaCloudOverview: '/Privatni/Aplikacije/Arena-Cloud',
	arenaCloudUserGuide: '/Privatni/Aplikacije/Arena-Cloud/Uputstvo-za-koriscenje',
	balkanMusicOverview: '/Privatni/Aplikacije/Balkan-Myusic',
	balkanMusicUserGuide: '/Privatni/Aplikacije/Balkan-Myusic/Uputstvo-za-koriscenje',
	deezerOverview: '/Privatni/Aplikacije/Deezer',
	deezerUserGuide: '/Privatni/Aplikacije/Deezer/Uputstvo-za-koriscenje',
	nbaOverview: '/Privatni/Aplikacije/NBA',
	nbaUserGuide: '/Privatni/Aplikacije/NBA/Uputstvo-za-koriscenje',
	mtelStore: '/Privatni/Aplikacije/mtel-store',
	listOfApps: '/Privatni/Aplikacije/mtel-aplikacije',
	// Support
	request: '/Privatni/Online-zahtjevi',
	complaint: '/Privatni/Prigovori',
	incident: '/Privatni/Smetnje',
} as { [index: string]: string };
